import DbDelegator from './DbDelegator';
export default DbDelegator;
